import { useDesignContext } from '../contexts/design.context'
import { ViewSelector } from '../../style-edit/subcomponents/style-edit-form/ViewSelector'
import React from 'react'

export function ViewSelectorWrapper() {
  const { views, selectedView, selectView } = useDesignContext()
  return <ViewSelector views={views} onSelectView={selectView} currentView={selectedView} />
}